module.exports = __webpack_public_path__ + "img/home-image.bfebb99e.png";